module.exports = __webpack_public_path__ + "img/gplay-qr.bd70d4db.svg";